import React from "react";
import { useT } from "../i18n/I18nProvider";

export default function About() {
  const { t } = useT();
  const stats = [
    { k: t("about.stat_years_k"), v: t("about.stat_years_v") },
    { k: t("about.stat_pieces_k"), v: t("about.stat_pieces_v") },
    { k: t("about.stat_family_k"), v: t("about.stat_family_v") },
  ];
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 md:py-28 warm-grain"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-10 grid md:grid-cols-12 gap-10 md:gap-16 items-start">
        <div className="md:col-span-5">
          <div className="text-[12px] uppercase tracking-[0.22em] text-[#b8420f] font-bold mb-4">
            {t("about.eyebrow")}
          </div>
          <h2 className="font-display font-black text-stone-900 text-[38px] md:text-[48px] leading-[1.05] tracking-tight">
            <span className="fancy-underline">{t("about.h_a")}</span>
            <br />
            <span className="italic text-[#b8420f]">{t("about.h_b")}</span>
          </h2>
        </div>

        <div className="md:col-span-7 space-y-5 text-stone-700 text-[17px] leading-[1.75]">
          <p>{t("about.p1")}</p>
          <p>{t("about.p2")}</p>
          <p>{t("about.p3")}</p>

          <div className="flex flex-wrap gap-6 pt-4">
            {stats.map((s, i) => (
              <div
                key={i}
                className="flex items-baseline gap-3 border-l-2 border-[#b8420f] pl-4"
                data-testid={`stat-${i}`}
              >
                <div className="font-display font-black text-3xl text-[#14532d]">{s.k}</div>
                <div className="text-[13px] text-stone-500">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
